import MarkdownDisplay from "./MarkdownDisplay";
import MarkdownEditor from "./Editor";
import markdownToDraft from "./markdownToDraft";
import { convertToRaw, EditorState, convertFromRaw } from "draft-js";
// extract editor state from text, rawState
// contain legacy extract function
function textToEditorState(text) {
  if (!text) return EditorState.createEmpty();
  let markToRawDraft;
  try {
    markToRawDraft = JSON.parse(text);
  } catch (error) {
    // legacy move
    markToRawDraft = markdownToDraft(text, {
      preserverNewLines: true,
    });
  }
  const contentState = convertFromRaw(markToRawDraft);
  const editorState = EditorState.createWithContent(contentState);
  return editorState;
}
function editorStateToJson(editorState) {
  let currentContent = editorState.getCurrentContent();
  let rawContent = convertToRaw(currentContent);
  return JSON.stringify(rawContent);
}
export {
  MarkdownEditor,
  MarkdownDisplay,
  textToEditorState,
  editorStateToJson,
};



// WEBPACK FOOTER //
// ./src/component/Markdown/index.js